import React, { useState } from 'react';
import { HatTokenValidation } from '@dataswift/hat-js/lib/utils/HatTokenValidation';

import { config } from '../../configs/config';
import { UserRoles } from '../../constants/role';

type AuthUser = {
  isAuthenticated: boolean;
  token: string;
  role: UserRoles;
};

type AuthContextType = {
  user: AuthUser;
  loginPDA: (token: string) => void;
  logout: () => void;
  logoutAndRedirect: (path: string) => void;
  loginCRM: (token: string) => void;
  loginMerchant: (token: string, rememberMe?: boolean) => void;
};

const contextDefaultValues: AuthContextType = {
  user: {
    isAuthenticated: false,
    token: '',
    role: UserRoles.EMPTY,
  },
  loginPDA: () => { },
  logout: () => { },
  logoutAndRedirect: () => { },
  loginCRM: () => { },
  loginMerchant: () => { },
};

export const AuthContext = React.createContext<AuthContextType>(contextDefaultValues);

const AuthProvider: React.FC = ({ children }) => {
  const [user, setUser] = useState<AuthUser>({
    isAuthenticated: !!localStorage.getItem(config.userRoleKey),
    token: '',
    role: (localStorage.getItem(config.userRoleKey) as UserRoles) || UserRoles.EMPTY,
  });

  return (
    <AuthContext.Provider
      value={{
        user,
        loginPDA: (token: string) => {
          if (token && !HatTokenValidation.isEncodedTokenExpired(token)) {
            localStorage.setItem(config.jwtTokenKey, token);
            localStorage.setItem(config.userRoleKey, UserRoles.PDA);

            setUser({
              isAuthenticated: true,
              token: token,
              role: UserRoles.PDA,
            });  
          }
        },
        logout: () => {
          const localMerchant = localStorage.getItem(config.userRoleKey) === "MERCHANT" ? true : false;
          const sessMerchant = sessionStorage.getItem(config.userRoleKey) === "MERCHANT" ? true : false;

          localStorage.removeItem(config.jwtTokenKey);
          localStorage.removeItem(config.userRoleKey);
          sessionStorage.removeItem(config.jwtTokenKey);
          sessionStorage.removeItem(config.userRoleKey);

          localStorage.removeItem('height');
          localStorage.removeItem('weight');
          localStorage.removeItem('bmi');
          localStorage.removeItem('gender');
          sessionStorage.removeItem('height');
          sessionStorage.removeItem('weight');
          sessionStorage.removeItem('bmi');
          sessionStorage.removeItem('gender');

          if (localMerchant || sessMerchant) {
            setUser({
              isAuthenticated: false,
              token: '',
              role: UserRoles.EMPTY,
            });
  
            console.log("Merchant Log out - redir to /merchant");
            window.location.replace('/');
          }
          else {
            console.log("User Log out - redir to /");
            window.location.replace('/');
          }
        },
        logoutAndRedirect: (path: string) => {
          localStorage.removeItem(config.jwtTokenKey);
          localStorage.removeItem(config.userRoleKey);
          sessionStorage.removeItem(config.jwtTokenKey);
          sessionStorage.removeItem(config.userRoleKey);

          localStorage.removeItem('height');
          localStorage.removeItem('weight');
          localStorage.removeItem('bmi');
          localStorage.removeItem('gender');
          sessionStorage.removeItem('height');
          sessionStorage.removeItem('weight');
          sessionStorage.removeItem('bmi');
          sessionStorage.removeItem('gender');

          setUser({
            isAuthenticated: false,
            token: '',
            role: UserRoles.EMPTY,
          });

          // console.log(`Redir Log out - redir to ${path}`);
          // window.location.replace(path);
        },
        loginCRM: (token: string) => {
          if (!token) return;

          localStorage.setItem(config.jwtTokenKey, token);
          localStorage.setItem(config.userRoleKey, UserRoles.CRM);

          setUser({
            isAuthenticated: true,
            token,
            role: UserRoles.CRM,
          });
        },
        loginMerchant: (token: string, rememberMe?: boolean) => {
          if (!token) return;

          if (rememberMe) {
            localStorage.setItem(config.jwtTokenKey, token);
            localStorage.setItem(config.userRoleKey, UserRoles.MERCHANT);
          } else {
            sessionStorage.setItem(config.jwtTokenKey, token);
            sessionStorage.setItem(config.userRoleKey, UserRoles.MERCHANT);
          }

          setUser({
            isAuthenticated: true,
            token,
            role: UserRoles.MERCHANT,
          });
        },
      }
      }
    >
      {children}
    </AuthContext.Provider >
  );
};

export default AuthProvider;
